export default __webpack_public_path__ + "static/media/pictogramTravel40.31028135.svg";